import { downloadTransactions } from './downloadTransactions'

import urls from './urls.json'

async function downloadSubscriptions(onSuccessEvent, onErrorEvent) {
  const url = urls.downloadSubscriptions
  downloadTransactions(onSuccessEvent, onErrorEvent, url)
}

export { downloadSubscriptions }
